import { gql, useQuery } from '@apollo/client';
import { GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables } from '../types/types';
import { useSessionStorage } from 'src/common/hooks';
import { SELECTED_BRAND_KEY, SELECTED_PRODUCT_KEY } from 'src/common';
import { BrandEnum } from 'src/common/enums/brand.enum';

export const getTermsAndConditionsForOffer = gql`
  query GetTermsAndConditionsForOffer($data: OfferTermsAndConditionsInput!, $id: String) {
    getTermsAndConditionsForOffer(id: $id, data: $data) {
      brandName
      brandCode
      brandLogo
      productName
      documents {
        fileId
        fileName
        src
      }
    }
  }
`;

export function useGetTermsAndConditionsForOffer(id?: string) {
  const { getValue: getSelectedBrand } = useSessionStorage<{ code: BrandEnum, name: string }>(SELECTED_BRAND_KEY);
  const { getValue: getSelectedProduct } = useSessionStorage<{ brandCode: BrandEnum, code: string, name: string}[]>(SELECTED_PRODUCT_KEY);

  const selectedBrand = getSelectedBrand();
  const selectedProduct = getSelectedProduct()?.find((prod) => prod.brandCode === selectedBrand?.code);
  const mainIdentifier = id || selectedProduct?.code;

  const { data: result, loading, error, refetch } = useQuery<GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables>(
    getTermsAndConditionsForOffer,
    {
      variables: { 
        id,
        data: {
          productCodes: selectedProduct?.code ? [selectedProduct?.code] : undefined,
          brandCode: selectedBrand?.code,
          productName: selectedProduct?.name,
        } 
      },
      // skip: !id && !selectedProduct?._id,
    }
  );

  return {
    termsAndConditions: mainIdentifier ? result?.getTermsAndConditionsForOffer : null,
    loading,
    error,
    refetch,
  };
}
